<template>
  <div>
    <el-scrollbar height="100%" ref="scrollbar" class="ShowCreateMelkUser">
      <div class="createMelkHeader phoneBookHeader">
        <div class="createMelkHeaderContainer">
          <div class="createMelkHeaderTitle">
            <h1>مخاطبین من</h1>
          </div>
          <div class="showFormBtn" @click="formTypeHandler('contant')">
            <i class="fa-solid fa-plus"></i>
          </div>
          <div @click="closeBtn" class="ShowIconVsIcon">
            <i class="fas fa-arrow-left" style="font-size: 24px"></i>
          </div>
        </div>
      </div>

      <div class="phoneBookMain phoneBookListMain">
        <div class="phoneBookMainContainer phoneBook">
          <div
            class="containerSideForm"
            v-if="formType == 'applicant'"
            :class="{ show: showApplicant }"
          >
            <div class="formHeader">
              <div class="formHeaderTitle">افزودن تقاضا</div>
              <div
                class="formResetBtn"
                v-if="formType == 'applicant'"
                @click="formTypeHandler('contant')"
              >
                افزودن مخاطب
              </div>
              <div
                class="ShowIconVsIcon"
                @click="formCloseHandler('applicant')"
              >
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="formMain">
              <form class="addPhoneForm">
                <div class="formGroup">
                  <label class="formGroupLabel"
                    >متقاضی :{{ user_select }}</label
                  >
                </div>
                <div class="groupFlex">
                  <div class="formGroup">
                    <label class="formGroupLabel">نوع درخواست</label>
                    <el-select v-model="applicantForm.main_category">
                      <el-option
                        v-for="(v, i) in $store.state.c_set.main_category2"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">گروه</label>
                    <el-select
                      @change="get_sub_category()"
                      v-model="applicantForm.category"
                    >
                      <el-option
                        v-for="(v, i) in $store.state.c_set.category"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                  <div
                    class="formGroup"
                    v-if="
                      (applicantForm.main_category != 'rent' &&
                        applicantForm.category == 'land') ||
                      applicantForm.category == 'garden'
                    "
                  >
                    <label class="formGroupLabel">نوع کاربری</label>
                    <el-select v-model="applicantForm.sub_category">
                      <el-option value="0">انتخاب کنید</el-option>
                      <el-option
                        v-for="(v, i) in front_show.sub_category_list"
                        :key="i"
                        :value="v.value"
                        :label="v.label"
                      />
                    </el-select>
                  </div>
                  <div
                    class="formGroup"
                    v-if="
                      (applicantForm.main_category != 'rent' &&
                        applicantForm.category == 'apartment') ||
                      applicantForm.category == 'land' ||
                      applicantForm.category == 'villa' ||
                      applicantForm.category == 'garden'
                    "
                  >
                    <label class="formGroupLabel">نوع سند</label>
                    <el-select v-model="applicantForm.doc_type">
                      <el-option
                        v-for="(v, i) in $store.state.c_set.doc_type"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                  <div
                    class="formGroup"
                    v-if="
                      applicantForm.category != 'land' &&
                      applicantForm.category != 'garden'
                    "
                  >
                    <label class="formGroupLabel">حداکثر متراژ بنا</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput numberInput"
                      v-model="front_show.building_area"
                      @input="building_area_input"
                    />
                  </div>
                  <div
                    class="formGroup"
                    v-if="
                      (applicantForm.main_category != 'rent' &&
                        applicantForm.category == 'land') ||
                      applicantForm.category == 'villa' ||
                      applicantForm.category == 'garden'
                    "
                  >
                    <label class="formGroupLabel">برملک</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput"
                      v-model="front_show.width"
                      @input="width_input"
                    />
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">حداکثر متراژ زمین</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput numberInput"
                      v-model="front_show.land_area"
                      @input="land_area_input"
                    />
                  </div>
                  <div
                    class="formGroup"
                    v-if="
                      (applicantForm.main_category != 'rent' &&
                        applicantForm.category == 'land') ||
                      applicantForm.category == 'garden' ||
                      applicantForm.category == 'villa'
                    "
                  >
                    <label class="formGroupLabel">حداکثر متراژ کوچه</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput numberInput"
                      v-model="front_show.lane"
                      @input="lane_input"
                    />
                  </div>
                  <div
                    class="formGroup"
                    v-if="applicantForm.main_category != 'rent'"
                  >
                    <label class="formGroupLabel">حداکثر قیمت</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput numberInput"
                      v-model="front_show.total_price"
                      @input="total_price_input"
                    />
                  </div>
                  <div
                    class="formGroup"
                    v-if="applicantForm.main_category == 'rent'"
                  >
                    <label class="formGroupLabel">حداکثر رهن</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput numberInput"
                      v-model="front_show.mortgage_price"
                      @input="mortgage_price_input"
                    />
                  </div>
                  <div
                    class="formGroup"
                    v-if="applicantForm.main_category == 'rent'"
                  >
                    <label class="formGroupLabel"
                      >حداکثر اجاره</label
                    >
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput numberInput"
                      v-model="front_show.rent_price"
                      @input="rent_price_input"
                    />
                  </div>
                  <div
                    class="formGroup"
                    v-if="
                      applicantForm.category == 'apartment' ||
                      applicantForm.category == 'villa'
                    "
                  >
                    <label class="formGroupLabel">حداکثر تعداد اتاق</label>
                    <el-select v-model="applicantForm.bedroom">
                      <el-option :label="'بدون اتاق'" :value="0" />
                      <el-option
                        v-for="i in 8"
                        :key="i"
                        :value="i"
                        :label="`${i} اتاق`"
                      />
                      <el-option :value="9" :label="'بیش از 9 اتاق'" />
                    </el-select>
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">آسانسور</label>
                    <el-select v-model="applicantForm.elevator">
                      <el-option
                        v-for="(v, i) in $store.state.c_set.public_yes_no"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">پارکینگ</label>
                    <el-select v-model="applicantForm.parking">
                      <el-option
                        v-for="(v, i) in $store.state.c_set.public_yes_no"
                        :key="i"
                        :value="i"
                        :label="v"
                      />
                    </el-select>
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">منطقه</label>
                    <el-select v-model="applicantForm.district" placeholder="">
                      <el-option
                        v-for="(v, i) in front_show.district"
                        :key="i"
                        :value="v.key"
                        :label="v.label"
                      />
                    </el-select>
                  </div>
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">توضیحات</label>
                  <textarea
                    rows="2"
                    v-model="applicantForm.details"
                    class="formGroupTextInput"
                  ></textarea>
                </div>
              </form>
            </div>
            <div class="formSubmitBtnWrapper" :class="{ editForm: editMenu }">
              <div
                class="formSubmitBtn"
                v-if="!btn_loading && !editMenu"
                @click="send_ApplicantData('save', true)"
              >
                افزودن تقاضا
              </div>
              <div class="formSubmitBtn" v-if="btn_loading">
                <span class="loading"></span>
              </div>
            </div>
          </div>
          <div
            class="containerSideForm"
            v-if="formType == 'filter'"
            :class="{ show: showFilter }"
          >
            <div class="formHeader">
              <div class="formHeaderTitle">فیلتر</div>
              <div @click="formCloseHandler('filter')" class="ShowIconVsIcon">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="formMain">
              <form class="addPhoneForm">
                <div class="formGroup">
                  <label class="formGroupLabel">نام</label>
                  <input
                    type="text"
                    class="formGroupTextInput"
                    v-model="fillter.fname"
                    maxlength="30"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">نام‌خانوادگی</label>
                  <input
                    type="text"
                    class="formGroupTextInput"
                    v-model="fillter.lname"
                    maxlength="50"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">تلفن همراه</label>
                  <input
                    type="tel"
                    class="formGroupTextInput"
                    v-model="fillter.mobile"
                    maxlength="11"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    @input="fillter.mobile = fillter.mobile.replace(/\D/g, '')"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">تلفن ثابت</label>
                  <input
                    type="tel"
                    class="formGroupTextInput"
                    v-model="fillter.phone"
                    maxlength="11"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">نوع مخاطب</label>
                  <el-select v-model="fillter.category_id" placeholder="">
                    <el-option
                      v-for="(v, i) in $store.state.c_set.customer_cat"
                      :key="i"
                      :value="v.id"
                      :label="v.title"
                    />
                  </el-select>
                </div>
              </form>
            </div>
            <div class="formSubmitBtnWrapper editForm filterForm">
              <div class="formSubmitBtn">فیلتر</div>
              <div class="formResetBtn">پاکسازی</div>
              <div class="formSubmitBtn" v-if="btn_loading">
                <span class="loading"></span>
              </div>
            </div>
          </div>
          <div
            class="containerSideForm"
            v-if="showContant || editform"
            :class="{ show: showContant || editform }"
          >
            <div class="formHeader">
              <div class="formHeaderTitle" v-if="!editform">افزودن مخاطب</div>
              <div class="formHeaderTitle" v-if="editform">ویرایش مخاطب</div>
              <!-- <div class="formResetBtn" v-if="editform" @click="clear_form()">
                مخاطب جدید
              </div> -->
              <div @click="formCloseHandler('contant')" class="ShowIconVsIcon">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="formMain">
              <form class="addPhoneForm">
                <div class="formGroup">
                  <label class="formGroupLabel">نام</label>
                  <input
                    type="text"
                    class="formGroupTextInput"
                    v-model="form.fname"
                    maxlength="30"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">نام‌خانوادگی</label>
                  <input
                    type="text"
                    class="formGroupTextInput"
                    v-model="form.lname"
                    maxlength="50"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">تلفن همراه</label>
                  <input
                    type="tel"
                    class="formGroupTextInput numberInput"
                    v-model="form.mobile"
                    maxlength="11"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    @input="form.mobile = form.mobile.replace(/\D/g, '')"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">تلفن ثابت</label>
                  <input
                    type="tel"
                    class="formGroupTextInput numberInput"
                    v-model="form.phone"
                    maxlength="11"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    @input="form.phone = form.phone.replace(/\D/g, '')"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">نوع مخاطب</label>
                  <el-select v-model="form.category_id" placeholder="" multiple>
                    <el-option
                      v-for="(v, i) in $store.state.c_set.customer_cat"
                      :key="i"
                      :value="v.id"
                      :label="v.title"
                    />
                  </el-select>
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">آدرس</label>
                  <input
                    type="text"
                    class="formGroupTextInput"
                    v-model="form.address"
                    maxlength="100"
                  />
                </div>
                <div class="formGroup">
                  <label class="formGroupLabel">توضیحات</label>
                  <textarea
                    type="text"
                    rows="3"
                    class="formGroupTextInput"
                    v-model="form.details"
                    max-length="200"
                  ></textarea>
                </div>
              </form>
            </div>
            <div class="formSubmitBtnWrapper">
              <div
                class="formSubmitBtn"
                v-if="!btn_loading && !editform"
                @click="send_data('save', true)"
              >
                افزودن مخاطب
              </div>
              <div
                class="formSubmitBtn"
                v-if="!btn_loading && editform"
                @click="send_data('update', true)"
              >
                ویرایش مخاطب
              </div>
              <div class="formSubmitBtn" v-if="btn_loading">
                <span class="loading"></span>
              </div>
              <!-- <div class="formResetBtn" v-if="editform" @click="clear_form()">
                مخاطب جدید
              </div> -->
            </div>
          </div>
          <div
            class="containerSideForm contactDetails"
            v-if="showDetails"
            :class="[{ show: showDetails }]"
          >
            <div class="detailsHeader">
              <div class="headerRightOptions">
                <div
                  class="contactDeleteBtn"
                  @click="del_user(contactDetails.uid)"
                >
                  <i class="fas fa-trash"></i>
                </div>
                <div
                  class="contactEditBtn"
                  @click="handel_edit(contactDetails.uid)"
                >
                  <i class="fas fa-edit"></i>
                </div>
              </div>
              <div class="headerLeftOptions">
                <div class="formResetBtn" @click="formTypeHandler('contant')">
                  افزودن مخاطب
                </div>
                <div
                  class="contactBackBtn"
                  @click="formCloseHandler('details')"
                >
                  <i class="fas fa-arrow-left"></i>
                </div>
              </div>
            </div>
            <div v-if="LoadingSkeleton" class="detailsMain">
              <div class="contactProfile">
                <Skeletor class="profileLogoSk"/>
              </div>
              <div class="contactInfo">
                <div class="contactName">
                  <Skeletor class="contactNameSk"/>
                </div>
                <div class="contactNumber">
                  <Skeletor class="contactNumberSk"/>
                </div>
                <div class="userContactBtns">
                  <Skeletor class="contactBtnSk"/>
                  <Skeletor class="contactBtnSk"/>
                  <Skeletor class="contactBtnSk"/>
                </div>
              </div>
              <Skeletor class="contactRoleSk"/>
              <Skeletor class="userDescSk"/>
            </div>
            <div v-if="!LoadingSkeleton && contactDetails" class="detailsMain">
              <div class="contactProfile">
                <div class="profileLogo" :class="proabck">
                  {{ getEnglishLetter(contactDetails?.nickname) }}
                </div>
              </div>
              <div class="contactInfo">
                <div class="contactName">
                  {{ contactDetails?.nickname }}
                </div>
                <div class="contactNumber">
                  <i class="fas fa-phone"></i>
                  <span>{{ contactDetails?.mobile }}</span>
                </div>
                <div v-if="contactDetails?.phone" class="contactNumber">
                  <i class="fas fa-phone"></i>
                  <span>{{ contactDetails?.phone }}</span>
                </div>
                <div class="userContactBtns">
                  <a
                    :href="`tel:${contactDetails?.mobile}`"
                    class="contactBtn"
                    :class="proabck"
                  >
                    <i class="fas fa-phone"></i>
                  </a>
                  <a
                    :href="`sms:${contactDetails?.mobile}`"
                    class="contactBtn"
                    :class="proabck"
                  >
                    <i class="fas fa-message"></i>
                  </a>
                  <div
                    @click="shareContent(contactDetails)"
                    class="contactBtn"
                    :class="proabck"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div
                v-if="contactDetails && contactDetails.category_id"
                class="contactRole"
                :class="proabck"
              >
                {{ contactDetails.category_id }}
              </div>
              <div v-if="contactDetails && contactDetails.details" class="userDesc">
                <div class="descTitle">توضیحات</div>
                <div class="descContent">
                  {{ contactDetails.details }}
                </div>
              </div>
            </div>
          </div>
          <div class="containerMainContent phoneBookMainContent">
            <div class="contentHeader">
              <div class="headerSearchInput phoneBookSearch">
                <div class="searchInputWrapper">
                  <input
                    type="search"
                    class="searchInput"
                    placeholder="جستجوی مخاطب (نام نام خانوادگی / موبایل / تلفن )"
                    v-model="fillter.search"
                    inputmode="search"
                    enterkeyhint="search"
                    @input="handleSearch"
                    @keyup.enter="handleSearch"
                  />
                  <div class="searchBtn">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
                <div class="searchFilterBtn">
                  <VsxIcon
                    iconName="Sort"
                    :size="20"
                    color="#000"
                    type="linear"
                  />
                  <el-select
                    placeholder=""
                    @change="load_users('first')"
                    v-model="fillter.category_id"
                  >
                    <el-option value="" label="همه" />
                    <el-option
                      v-for="(v, i) in $store.state.c_set.customer_cat"
                      :key="i"
                      :value="v.id"
                      :label="v.title"
                    />
                  </el-select>
                </div>
              </div>
              <div class="headerTitleWrapper">
                <div class="headerTitle">لیست مخاطبین</div>
                <div class="resAddBtn" @click="formTypeHandler('contant')">
                  <div class="resAddBtnIcon">
                    <i class="fas fa-plus"></i>
                  </div>
                  <div class="resAddBtnTitle">افزودن مخاطب</div>
                </div>
              </div>
            </div>
            <div class="contentMain">
              <div v-if="LoadingSkeleton" class="usersList">
                <Skeletor v-for="i in 4" :key="i" class="userThumbSk"/>
              </div>
              <div v-if="!LoadingSkeleton && users_list.length > 0" class="usersList">
                <div
                  class="userThumb"
                  v-for="(v, i) in users_list"
                  :key="i"
                  @click="formTypeHandler('details', v.uid, v.nickname, v, i)"
                  :class="'cust_category' + i"
                >
                  <div class="userPic">
                    {{ getEnglishLetter(v.nickname) }}
                  </div>
                  <div class="userInfoWrapper">
                    <div class="userInfo">
                      <div class="infoName">{{ v.nickname }}</div>
                      <div class="infoLoc">{{ v.category_id }}</div>
                      <div class="infoPhone">{{ v.address }}</div>
                    </div>
                    <div class="moreInfoIcon">
                      <i class="fas fa-chevron-left"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="loadeMoreLoader" v-if="loadmore_loading && users_list.length > 0 && !LoadingSkeleton">
                <span class="custom-loader"></span>
              </div>
              <div
                v-if="users_list.length == 0 && !LoadingSkeleton"
                class="justify-center align-center mt-4"
                style="text-align: center; height: 90%"
              >
                <img
                  src="/img/notfound.png"
                  alt="Alt text"
                  width="320"
                  height="280"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import "vue3-toastify/dist/index.css";
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";
import { nextTick } from "vue";
import debounce from "lodash/debounce";
import { Share } from "@capacitor/share";
export default {
  components: {
    Skeletor,
  },
  data() {
    return {
      LoadingSkeleton: false,
      closeBtn1: false,
      color: "#2dc653",
      loadMoreTrigger: null,
      formType: "contant",
      users_list: [],
      fillter: {
        page: 1,
        search: "",
        category_id: "",
        role: "contact",
        per_page: 12,
      },
      isLoading: false,
      loadmore: true,
      loadmore_loading: false,
      showApplicant: false,
      contactDetails: null,
      applicantForm: {
        user_id: 0,
        main_category: "trade",
        category: "apartment",
        doc_type: "melk",
        building_area: "",
        land_area: "",
        // width: "",
        // lane: "",
        total_price: 0,
        mortgage_price: 0,
        rent_price: 0,
        prepayment: 0,
        bedroom: 0,
        parking: "no",
        elevator: "no",
        state: 26,
        city: 317,
        district: '',
        details: "",
        sub_category: "",
        status: "inProgress",
      },
      front_show: {
        building_area: "",
        land_area: "",
        // width: "",
        // lane: "",
        mortgage_price: 0,
        rent_price: 0,
        meter_price: 0,
        total_price: 0,
        state: [],
        city: [],
        district: [],
        sub_category_list: [],
      },
      form: {
        uid: 0,
        fname: "",
        lname: "",
        mobile: "",
        phone: "",
        sex: "man",
        address: "",
        category_id: [],
        details: "",
        role: "contact",
      },
      btn_loading: false,
      user_select: "",
      showFilter: false,
      proabck: "",
    };
  },
  computed: {
    showContant() {
      if (window.innerWidth > 1000) {
        return this.editform || this.showDetails ? false : true;
      } else {
        return this.$route.query.contant === "active";
      }
    },
    showDetails() {
      const active = this.$route.query.details;
      return active ? true : false;
    },
    editform() {
      return this.$route.query.editing === "active";
    },
  },
  methods: {
    async shareContent(contact) {
      try {
        await Share.share({
          title: "اشتراک گذاری شمال املاک",
          text: `${contact.nickname} - ${contact.mobile}`,
          url: "https://shomalamlak.ir",
          dialogTitle: "شمال املاک",
        });
      } catch (error) {
        console.error("خطا در اشتراک‌ گذاری:", error);
      }
    },
    getEnglishLetter(name) {
      if (!name) return "";
      const firstChar = name.trim().charAt(0);
      if (/[a-zA-Z]/.test(firstChar)) {
        return firstChar.toUpperCase();
      }

      return firstChar || "?";
    },
    building_area_input(event) {
      this.front_show.building_area = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.applicantForm.building_area = event.target.value.replace(
        /[^\d.-]/g,
        ""
      );
    },
    width_input(event) {
      this.front_show.width = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.applicantForm.width = event.target.value.replace(/[^\d.-]/g, "");
    },

    land_area_input(event) {
      this.front_show.land_area = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.applicantForm.land_area = event.target.value.replace(/[^\d.-]/g, "");
    },
    total_price_input(event) {
      this.front_show.total_price = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.applicantForm.total_price = event.target.value.replace(
        /[^\d.-]/g,
        ""
      );
    },

    lane_input(event) {
      this.front_show.lane = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.applicantForm.lane = event.target.value.replace(/[^\d.-]/g, "");
    },
    mortgage_price_input(event) {
      this.front_show.mortgage_price = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.applicantForm.mortgage_price = event.target.value.replace(
        /[^\d.-]/g,
        ""
      );
    },
    rent_price_input(event) {
      this.front_show.rent_price = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.applicantForm.rent_price = event.target.value.replace(
        /[^\d.-]/g,
        ""
      );
    },
    get_sub_category() {
      if (this.applicantForm.category == "land") {
        let self = this;
        this.helperGet(
          "get-post-sub-category",
          "category=" + this.form.category
        ).then((r) => {
          self.front_show.sub_category_list = r.data.rows;
          if (r.data.rows.length > 0)
            self.applicantForm.sub_category = r.data.rows[0].value;
        });
      }
    },
    get_district() {
      let self = this;
      this.helperGet("get-district", "id=" + this.applicantForm.city).then(
        (r) => {
          self.front_show.district = r.data;
        }
      );
    },
    applicantFormClear() {
      (this.form = {
        user_id: 0,
        main_category: "trade",
        category: "apartment",
        doc_type: "melk",
        building_area: "",
        land_area: "",
        // width: "",
        // lane: "",
        total_price: 0,
        mortgage_price: 0,
        rent_price: 0,
        prepayment: 0,
        bedroom: 0,
        parking: "no",
        elevator: "no",
        state: 26,
        city: 317,
        district: '',
        details: "",
        sub_category: "",
        status: "inProgress",
      }),
        (this.front_show = {
          building_area: "",
          land_area: "",
          // width: "",
          // lane: "",
          mortgage_price: 0,
          rent_price: 0,
          meter_price: 0,
          total_price: 0,
          state: [],
          city: [],
          district: [],
          sub_category_list: [],
        }),
        (this.editMenu = false);
    },
    formTypeHandler(type, uid, nickname, contact = null, i) {
      this.formType = type;
      this.user_select = nickname;
      this.applicantForm.user_id = uid;
      this.contactDetails = contact;

      this.get_district();

      this.formOpenHandler(type);

      this.proabck = "cust_cat_back" + i;
    },
    formOpenHandler(type) {
      const query = { ...this.$route.query };
      delete query.contant;
      delete query.details;
      delete query.editing;

      if (type == "contant") {
        query.contant = "active"
        this.$router.push({ query });
      } else if (type == "details") {
        query.details = this.contactDetails.uid;
        if (window.innerWidth > 1000) {
          this.$router.replace({ query });
        } else {
          this.$router.push({ query });
        }
      } else if (type == "edit") {
        query.editing = "active";
        this.$router.push({ query });
      }
    },
    formCloseHandler() {
      history.back();
    },
    send_ApplicantData(mode, close = false) {
      this.btn_loading = true;
      let url = "update-request";
      if (mode == "save") url = "save-request";

      this.helperPost(url, this.applicantForm).then((r) => {
        if (r.data.result == "1") {
          toast(r.data.msg, {
            type: "success",
            dangerouslyHTMLString: true,
          });
          this.applicantFormClear();
          let windowWidth = window.innerWidth;
          if (windowWidth < 1000 && close) {
            this.formCloseHandler("applicant");
          }
        } else {
          toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
            type: "error",
            dangerouslyHTMLString: true,
          });
          this.applicantFormClear();
        }
        this.btn_loading = false;
      });
    },
    handleSearch: debounce(function () {
      let self = this;
      if (
        this.fillter.search.trim().length >= 3 ||
        this.fillter.search.trim().length == 0
      ) {
        self.load_users("first");
      }
    }, 1200),

    handel_edit(id) {
      let self = this;
      this.helperGet("branch-user-info", "uid=" + id).then((res) => {
        self.form.uid = res.data.data.uid;
        self.form.fname = res.data.data.fname;
        self.form.lname = res.data.data.lname;
        self.form.mobile = res.data.data.mobile;
        self.form.phone = res.data.data.phone;
        self.form.address = res.data.data.address;
        self.form.sex = res.data.data.sex;
        self.form.details = res.data.data.details;
        self.form.category_id = res.data.data.category_id;
        self.formTypeHandler("edit");
      });
    },
    send_data(mode, close = false) {
      this.btn_loading = true;
      let url = "update-profile";
      if (mode == "save") url = "save-profile";

      if (this.form.fname == "") {
        toast("نام مخاطب را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (this.form.lname == "") {
        toast("نام خانوادگی مخاطب را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (this.form.mobile == "") {
        toast("تلفن همراه مخاطب را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (!/^09\d{9}$/.test(this.form.mobile)) {
        toast("فرمت تلفن همراه وارد شده صحیح نمی باشد", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (this.form.category_id == "") {
        toast("نوع مخاطب را انتخاب کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      }

      this.helperPost(url, this.form).then((r) => {
        if (r.data.result == "1") {
          toast(r.data.msg, {
            type: "success",
            dangerouslyHTMLString: true,
          });
          this.clear_form();
          this.load_users("first");
          let windowWidth = window.innerWidth;
          if (windowWidth < 1000 && close) {
            this.formCloseHandler("contant");
          }
        } else {
          toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
            type: "error",
            dangerouslyHTMLString: true,
          });
          this.clear_form();
        }
        this.btn_loading = false;
      });
    },
    clear_form() {
      this.form = {
        uid: 0,
        fname: "",
        lname: "",
        mobile: "",
        phone: "",
        sex: "man",
        address: "",
        category_id: [],
        details: "",
        role: "contact",
      };
      this.editform = false;
    },

    load_users(param) {
      let self = this;
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.LoadingSkeleton = true;
        this.users_list = [];
        this.fillter.page = 1;
      }

      this.helperPost("branch-users-list", self.fillter).then((r) => {
        if (r.data.result == 0) {
          self.users_list = [];
          if (param != "first") {
            self.fillter.page -= 1;
          }
        } else {
          self.users_list = self.users_list.concat(r.data.list.list);
          if (r.data.list.total_page == self.fillter.page) {
            self.loadmore = false;
          }
          if (this.showDetails) {
            const selected = this.$route.query.details;
            this.contactDetails = this.users_list.find(data => {
              return data.uid == selected
            })
          }
        }
        self.LoadingSkeleton = false;
        self.loadmore_loading = false;
      });
    },

    closeBtn() {
      history.back();
      document.body.style = "overflow-y: auto;";
    },

    checkWindowSize() {
      if (window.innerWidth <= 1250) {
        this.closeBtn1 = false;
      } else {
        this.closeBtn1 = true;
      }
    },

    del_user(uid) {
      this.$swal
        .fire({
          title: "حذف مخاطب",
          text: "آیا مطمئن هستید که می‌خواهید این مخاطب را حذف کنید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("user-delete", { foo: [uid] })
                .then((r) => {
                  if (r.data.result == 1) {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    history.back();
                    self.load_users("first");
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },

    loadTheme() {
      const width = window.innerWidth;
      if (width >= 1250) {
        this.color = "#2dc653";
      } else {
        this.color = "#f5f5f5";
      }
    },
    handleScroll() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_users();
        }
      }
    },
  },
  watch: {
    // ShowApplicant(newValue) {
    //   this.$emit("filterStatus", newValue);
    // },
    // CloseBtn1(newValue) {
    //   this.$emit("filterStatus", newValue);
    // },
    showDetails() {
      if (this.showDetails) {
        if (this.contactDetails == null) {
          this.LoadingSkeleton = true;
          const selected = this.$route.query.details;
          this.contactDetails = this.users_list.find(data => {
            return data.uid == selected
          })
          setTimeout(() => {
            this.LoadingSkeleton = false;
          }, 1500)
        }
      } else {
        this.contactDetails = null;
      }
    },
    "$route.query.details": {
      handler() {
        const selected = this.$route.query.details;
        if (selected) {
          this.contactDetails = this.users_list.find(data => {
            return data.uid == selected
          })
        }
      }
    }
  },
  beforeUnmount() {
    const wrap = this.$refs.scrollbar?.wrapRef;
    if (wrap) {
      wrap.removeEventListener("scroll", this.handleScroll);
    }
  },

  async mounted() {
    this.load_users("first");
    this.checkWindowSize();

    setInterval(() => {
      this.loadTheme();
    }, 100);

    await nextTick();
    this.loadMoreTrigger = this.$refs.loadMoreTrigger;
    this.$nextTick(() => {
      const wrap = this.$refs.scrollbar?.wrapRef;
      console.log("wraaaaaaaaaaapp", wrap);
      if (wrap) {
        wrap.addEventListener("scroll", this.handleScroll);
      }
    });
  },
};
</script>

<style scoped lang="scss">
.apartmentsLoadMoreDataButton {
  width: 100%;
  margin: 36px;
}
.apartmentsLoadMoreDataButton .loadButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  text-align: center;
  background: #2dc653;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.9rem;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}

.loader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader2 {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}
.cust_cat_lbl0 {
  color: #0096c7 !important;
}
.cust_cat_lbl1 {
  color: #ffd60a !important;
}
.cust_cat_lbl2 {
  color: #ff5d8f !important;
}
.cust_cat_lbl3 {
  color: #00f5d4 !important;
}
.cust_cat_lbl4 {
  color: #9d4edd !important;
}
.cust_cat_lbl5 {
  color: #ff7b00 !important;
}

.cust_cat_back0 {
  background: #0096c7 !important;
}
.cust_cat_back1 {
  background: #ffd60a !important;
}
.cust_cat_back2 {
  background: #ff5d8f !important;
}
.cust_cat_back3 {
  background: #00f5d4 !important;
}
.cust_cat_back4 {
  background: #9d4edd !important;
}
.cust_cat_back5 {
  background: #ff7b00 !important;
}

textarea {
  &:focus {
    outline: none;
  }
}

.numberInput {
  direction: ltr !important;
  text-align: left !important;
}
.thumbDetailsBtn,
.deleteButton,
.editButton,
.backButton {
  cursor: pointer;
}

.dark {
  .phoneBookMain {
    .phoneBookMainContainer {
      .containerMainContent {
        .contentHeader {
          .headerSearchInput {
            &.phoneBookSearch {
              .searchFilterBtn {
                :deep(svg) {
                  position: relative;
                  z-index: 9;
                }
              }
            }
          }
        }
      }
    }
  }
}

.profileLogoSk {
  width: 8rem;
  height: 8rem;
  border-radius: 9999px;
  background: rgb(163, 219, 213);
}

.contactNameSk {
  width: 148px;
  height: 32px;
  margin-inline: auto;
  border-radius: 9999px;
  background: rgb(163, 219, 213);
}

.contactNumberSk {
  width: 108px;
  height: 20px;
  margin-inline: auto;
  border-radius: 9999px;
  background: rgb(163, 219, 213);
}

.contactBtnSk {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  background: rgb(163, 219, 213);
}

.contactRoleSk {
  width: 100%;
  max-width: 380px;
  height: 42px;
  margin-bottom: 24px;
  border-radius: 9999px;
  background: rgb(163, 219, 213);
}

.userDescSk {
  width: 100%;
  max-width: 380px;
  height: 162px;
  border-radius: 16px;
  background: rgb(163, 219, 213);
}

.userThumbSk {
  width: 100%;
  height: 88px;
  border-radius: 8px;
  background: rgb(163, 219, 213);

  &:not(:last-child) {
    margin-bottom: 16px;
  }
}

@media (min-width: 1000px) {
  .phoneBookMain {
    .phoneBookMainContainer {
      .containerSideForm {
        &.contactDetails {
          .detailsMain {
            padding-inline: 24px !important;
          }
        }
      }
    }
  }
}
</style>
